import React from "react";

const schemeItems = [
  "A maximum loan of up to Rs 20.00 lakh is available for technical and professional courses in India.",
  "For courses abroad, a maximum loan amount of Rs 30.00 lakh is available.",
  "The loan is available for courses with a maximum duration of five years.",
];

const interestItems = [
  "3% p.a. under Credit Line-1",
  "8% p.a. under Credit Line-2",
];

const eligibilityItems = [
  "Belong to a notified minority community.",
  "Have secured admission to a recognized educational institution through merit or entrance examination, wherever applicable.",
  "Meet the family income limits prescribed by NMDFC.",
  "Maintain satisfactory academic performance as required by the institution.",
  "Fulfill all other conditions specified under the scheme.",
];

const documentItems = [
  "Loan application form",
  "Aadhaar Card",
  "Identity and address proof",
  "Income certificate",
  "Admission letter issued by the educational institution",
  "Fee structure or demand letter",
  "Academic certificates and mark sheets",
  "Passport (for overseas education)",
  "Passport-size photographs",
  "Bank account details",
  "Any other documents prescribed by the implementing agency",
];

const purposeItems = [
  "Tuition and admission fees",
  "Examination, laboratory, and library charges",
  "Purchase of books, computers, instruments, and study materials",
  "Hostel and boarding expenses",
  "Educational tours, project work, and thesis expenses",
  "Travel expenses for overseas education, wherever applicable",
  "Other educational expenses approved under the scheme",
];

const EducationLoanSchemeContent = () => {
  return (
    <div className="space-y-7 text-[#333333]">
      <section className="space-y-3">
        <h2 className="text-lg font-bold text-[#183967]">Introduction</h2>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          The NMDFC Education Loan Scheme aims to provide financial assistance
          to deserving students belonging to notified minority communities for
          pursuing higher education in India and abroad. The scheme enables
          students to access quality education in professional, technical, and
          vocational fields, thereby enhancing their employability and career
          prospects while reducing the financial burden on their families.
        </p>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          This scheme is also for individual beneficiaries. Education Loan is
          provided with an objective to facilitate job-oriented education for the
          eligible persons from targeted Minority communities.
        </p>
        <div className="space-y-2">
          <p className="text-[15px] leading-[1.7] text-[#111827]">
            Under this scheme:
          </p>
          <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
            {schemeItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="space-y-2">
          <p className="text-[15px] leading-[1.7] text-[#111827]">
            The rate of interest is:
          </p>
          <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
            {interestItems.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </div>
        <p className="text-justify text-[15px] leading-[1.75] text-[#111827]">
          A 3% p.a. rebate in the rate of interest is available for female
          beneficiaries under Credit Line-2. The loan is repayable within a
          maximum period of five years after completion of the course.
        </p>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Eligibility</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants should:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {eligibilityItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">
          Documents Required
        </h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          Applicants may be required to submit:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {documentItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>

      <section className="space-y-2">
        <h2 className="text-lg font-bold text-[#183967]">Purpose of Loan</h2>
        <p className="text-[15px] leading-[1.7] text-[#111827]">
          The education loan may be used for:
        </p>
        <ul className="ml-6 list-disc space-y-1.5 text-[15px] leading-[1.65] text-[#111827]">
          {purposeItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default EducationLoanSchemeContent;
